export const GET_FINANCIAL_MODELS_REQUEST = 'GET_FINANCIAL_MODELS_REQUEST';
export const GET_FINANCIAL_MODELS_SUCCESS = 'GET_FINANCIAL_MODELS_SUCCESS';
export const GET_FINANCIAL_MODELS_FAILURE = 'GET_FINANCIAL_MODELS_FAILURE';
